import { ICreditAttachDocumentsParams, ICreditAttachDocumentsResponse, ICreditRepository } from "@/core/repositories/credit";

export class AttachCreditDocumentsUseCase {
  constructor(private readonly creditRepository: ICreditRepository) {}

  async execute(params: ICreditAttachDocumentsParams, currentPage: number): Promise<ICreditAttachDocumentsResponse> {
    return this.creditRepository.attachCreditDocuments(params, currentPage);
  }
}
